<div
  class="fixed right-0 left-0 bottom-0 shadow shadow-top w-full"
  [style.z-index]="50"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  *ngIf="cart$ | async"
>
  <div class="mx-auto">
    <div *ngIf="!(hideCartParameters$ | async)">
      <app-cart-parameters-overview
        [iconBackgroundColor]="iconBackgroundColor"
        [iconColor]="iconColor"
        [textColor]="labelColor"
      ></app-cart-parameters-overview>
    </div>

    <div
      *ngIf="(cartProducts$ | async)?.length"
      class="w-full px-3 kiosk:px-12 pb-3 kiosk:py-8 flex items-center"
      [class.pb-6]="isNotched"
      [class.pt-2]="hideCartParameters$ | async"
    >
      <div class="py-0.5 mr-1.5 xm:mr-7.5 kiosk:hidden">
        <button
          class="text-2xl w-13 h-12.5 rounded-full"
          [style.backgroundColor]="buttonBackgroundColor | contentBuilderColor"
          [style.color]="buttonTextColor | contentBuilderColor"
          (click)="navigateToCart()"
        >
          {{ (cartProducts$ | async)?.length }}
        </button>
      </div>
      <div class="flex-1">
        <app-cart-footer-button-atom
          [label]="'shop-page.view-basket' | translate"
          [disabled]="isNavigationToCartInProgress"
          [iconUrl]="isNavigationToCartInProgress ? 'assets/images/spinner.svg' : undefined"
          [icon]="!isNavigationToCartInProgress ? 'icon-shopping-bag' : undefined"
          [buttonBackgroundColor]="buttonBackgroundColor"
          [buttonTextColor]="buttonTextColor"
          (click)="navigateToCart()"
        ></app-cart-footer-button-atom>
      </div>
      <div
        *ngIf="order$ | async as order"
        class="hidden xm:block ml-7.5"
      >
        <app-price-atom
          [format]="true"
          [amount]="order?.final_price ?? 0"
        ></app-price-atom>
      </div>
    </div>
  </div>
</div>
